import { TabNumber, TabPaths } from '../../constants';

/**
 * @method getPathForTabNumber
 * @description To get path for respective tab number
 * @param number
 * @returns path string
 */
export const getPathForTabNumber = (tabNumber: number) => {
  switch (tabNumber) {
    case 1:
      return TabPaths.SR;
    case 2:
      return TabPaths.PR;
    case 3:
      return TabPaths.SER;
    case 4:
      return TabPaths.FSR;
    case 5:
      return TabPaths.CR;
    case 6:
      return TabPaths.STR;
    default:
      return TabPaths.SR;
  }
};

/**
 * @method getNumberForPath
 * @description To get tab number for the location string passed
 * @param path
 * @returns number
 */
export const getNumberForPath = (path: string) => {
  const str = Object.keys(TabPaths).find((p) => path.includes(TabPaths[p as keyof typeof TabPaths]));
  return str && typeof str === 'string' ? TabNumber[str as keyof typeof TabNumber] : TabNumber.SR;
};

export const ERRORS_SR = {
  noResponse: 'No response',
  statusCode: '409'
};
